import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Gift, Zap } from "lucide-react";
import { submitLead } from "../lib/api";
import { toast } from "sonner";

export default function LeadPopup() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", city: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("lead_popup_shown")) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("lead_popup_shown", "1");
    }, 12000);
    return () => clearTimeout(t);
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Please enter your name and phone number");
      return;
    }
    setLoading(true);
    try {
      await submitLead({ ...form, source: "popup" });
      toast.success("Thank you! Our expert will call you within 24 hours.");
      setOpen(false);
      setForm({ name: "", phone: "", city: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden border-0" data-testid="lead-popup-dialog">
        <div className="relative bg-slate-900 p-6 text-white border-b-4 border-yellow-400">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl bg-yellow-400 flex items-center justify-center">
              <Gift className="w-6 h-6 text-slate-900" />
            </div>
            <div className="text-xs uppercase font-bold tracking-widest text-yellow-400">Limited time</div>
          </div>
          <DialogHeader className="space-y-1 text-left">
            <DialogTitle className="text-2xl font-heading text-white">Free Site Visit + ₹5,000 Off</DialogTitle>
            <DialogDescription className="text-slate-300 text-sm">
              Get a free roof survey and up to ₹5,000 cashback on your installation. Drop your number below.
            </DialogDescription>
          </DialogHeader>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-3" data-testid="lead-popup-form">
          <Input
            placeholder="Your Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="popup-input-name"
          />
          <Input
            placeholder="Phone Number"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            data-testid="popup-input-phone"
          />
          <Input
            placeholder="City (optional)"
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
            data-testid="popup-input-city"
          />
          <Button type="submit" disabled={loading} className="w-full bg-yellow-400 hover:bg-yellow-500 text-slate-900" data-testid="popup-submit-btn">
            <Zap className="w-4 h-4 mr-2" /> {loading ? "Submitting..." : "Claim My Free Visit"}
          </Button>
          <p className="text-xs text-center text-slate-500">🔒 Your details are safe with us. No spam calls.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
}
